/* eslint-disable max-len */
/* eslint-disable arrow-body-style */
/* eslint-disable no-confusing-arrow */
/* eslint-disable function-paren-newline */
/* eslint-disable arrow-parens */
import * as XLSX from 'xlsx'
import {
  cartesian,
  groupBy,
  handleDataOrder,
  handleDataOrderByPercentage,
  sortArrayBaseOnAnotherArray,
  sumUpdate,
  safeSheetName
} from '_utils/function'
import {
  BUYER_ORDER_CANCELED,
  BUYER_REFUNDED,
  HOST_ORDER_CANCELED,
  BUYER_PAID,
} from '_utils/constant'
import { initProductsFromOrders } from './helperFunctions/function'
import { export1 } from './helperFunctions/export1'

const format1 = 1

export function handleExportMultipleEventAndOrder(listTotalOrderAfterFilter, format) {
  const fmt = Number(format)

  function export2(arrayEvent) {
    const listTitle = []
    const wb = XLSX.utils.book_new()
    const eventHeaders = arrayEvent.map(e => e.title)
    for (let n = 0; n < arrayEvent?.length; n++) {
      const {
        title,
        orders = [],
        adminCost,
        discount,
        deliveryCost,
        isPercentage = false
      } = arrayEvent[n] || {}

      const products = initProductsFromOrders(orders)

      const { totalAllOrder, adminCostAllOrder, paymentCollected } = isPercentage ? handleDataOrderByPercentage(
        orders,
        adminCost,
        discount,
        deliveryCost
      ) : handleDataOrder(orders, adminCost, discount, deliveryCost)

      const ordersActive = orders.filter(
        (order) =>
          order.buyerStatus !== BUYER_ORDER_CANCELED &&
          order.buyerStatus !== BUYER_REFUNDED &&
          order.status !== HOST_ORDER_CANCELED
      )

      const total = [
        ['Total Purchase', `$${totalAllOrder}`],
        ['Admin Fee', `$${adminCostAllOrder}`],
        ['Payment Confirmed', `$${paymentCollected}`],
        [''],
      ]
      const totalOrderArr = [
        ...ordersActive.reduce((acc, curr) => {
          const order = acc.find((p) => p.pid === curr.pid)
          if (order) {
            const index = acc.indexOf(order)
            acc[index].count += curr.pQuantity
          } else {
            curr.count = curr.pQuantity
            acc.push(curr)
          }
          return acc
        }, []),
      ]
     const rowsOfTotalOrder = new Array(totalOrderArr.length)
     const { productIdList } = arrayEvent[n]
     const rowsOfContact = new Array(0)
      let colsOfProduct = []
      for (let i = 0; i < totalOrderArr.length; i++) {
        const order = totalOrderArr[i]
        const listTempProName = []
        const listTempProPrice = []
        const subitems = products.find((x) => x.id === order.pid).subItems || []
        subitems.sort((a, b) => (a.type > b.type ? 1 : b.type > a.type ? -1 : 0))
        for (let j = 0; j < subitems.length; j++) {
          const subitem = subitems[j]
          const optionsTempName = []
          const optionsTempPrice = []
          const { list, required } = subitem
          if (required === 0) {
            optionsTempName.push('')
            optionsTempPrice.push(0)
          }
          for (let k = 0; k < list.length; k++) {
            const option = list[k]
            optionsTempName.push(option.name)
            optionsTempPrice.push(option.price)
          }
          listTempProName.push(optionsTempName)
          listTempProPrice.push(optionsTempPrice)
        }

        let cartesianProductPrice = []
        if (listTempProPrice.length) {
          cartesianProductPrice = cartesian(listTempProPrice.map((item) => item))
        }

        if (!listTempProName.length) listTempProName.push([order.pName])
        if (!listTempProPrice.length) listTempProPrice.push([order.pPrice])

        const cartesianProductName = cartesian(listTempProName.map((item) => item))

        const _products = []
        for (let l = 0; l < cartesianProductName.length; l++) {
          const productName = cartesianProductName[l].toString()
          let productPrice = 0
          if (cartesianProductPrice.length) {
            productPrice = cartesianProductPrice[l].reduce((a, b) => a + b, 0)
          }
          _products.push({ pid: order.pid, name: productName, price: productPrice })
        }
        colsOfProduct = [
          ...colsOfProduct,
          ..._products.map((product) => {
            if (subitems.length) {
              let productName
              if (product.name) {
                productName =
                  order?.pPurchaseType === 'item'
                    ? `${order.pName}(INDIVIDUAL) (${product.name})`
                    : order?.pPurchaseType === 'case' && order?.pSplitCasePurchase
                      ? `${order.pName}(CASE/CARTON) (${product.name})`
                      : `${order.pName} (${product.name})`;
              } else {
                productName = order?.pPurchaseType === 'item'
                  ? `${order.pName}(INDIVIDUAL)`
                  : order?.pPurchaseType === 'case' && order?.pSplitCasePurchase
                    ? `${order.pName}(CASE/CARTON)`
                    : order.pName;
              }
              return {
                ...product,
                name: productName,
              }
            }
            return { ...product,
              name: order?.pPurchaseType === 'item'
                  ? `${order.pName}(INDIVIDUAL)`
                  : order?.pPurchaseType === 'case' && order?.pSplitCasePurchase
                    ? `${order.pName}(CASE/CARTON)`
                    : order.pName }
          }),
        ]

        totalOrderArr[i] = { ...order, subItems: subitems }
      }

     const _totalOrderArr = sortArrayBaseOnAnotherArray(totalOrderArr, [...productIdList])
      const _sortColsOfProduct = sortArrayBaseOnAnotherArray(colsOfProduct, [...productIdList])
      for (let i = 0; i < products.length; i++) {
        const productTemp = products[i]
        for (let j = 0; j < _sortColsOfProduct.length; j++) {
          const product = _sortColsOfProduct[j]
          if (product.pid === productTemp.id) {
            _sortColsOfProduct[j] = { ...product, price: product.price + productTemp.price }
          }
        }
      }
      const groupByOrderWithBuyerName = groupBy(ordersActive, 'uName')
      const listOfBuyerName = Object.keys(groupByOrderWithBuyerName)
      let colProductName = []
      let colProductPrice = []
      let productNameAndPrice = []

      const paidAmounts = []
      const unpaidAmounts = []
      const eventParticipations = []

      if (Array.isArray(listOfBuyerName)) {
        for (let i = 0; i < listOfBuyerName.length; i++) {
          const buyerName = listOfBuyerName[i]
          // const { uPhone: buyerPhone } = groupByOrderWithBuyerName[buyerName][0]
          for (let j = 0; j < groupByOrderWithBuyerName[buyerName].length; j++) {
            const objOrder = groupByOrderWithBuyerName[buyerName][j]
            const { pName, pSubItems } = objOrder

            let productName = objOrder.pPurchaseType === 'item'
              ? `${pName}(INDIVIDUAL)`
              : objOrder.pPurchaseType === 'case' && objOrder.pSplitCasePurchase
                ? `${pName}(CASE/CARTON)`
                : pName
            if (pSubItems.length) {
              productName = `${productName} (${pSubItems
                .sort((a, b) => (a.type > b.type ? 1 : b.type > a.type ? -1 : 0))
                .map((s) => s.qty > 1 ? `${s.name} x${s.qty}` : s.name)
                .toString()})`
            }

            groupByOrderWithBuyerName[buyerName][j] = { ...objOrder, pName: productName, pNameAndPid: `${productName} ${objOrder.pid}` }
          }

          const _sum = sumUpdate(groupByOrderWithBuyerName[buyerName], 'pNameAndPid').sort((a, b) =>
            a.pName > b.pName ? 1 : b.pName > a.pName ? -1 : 0
          )

          productNameAndPrice.push(..._sum)
        }
      }

      productNameAndPrice = Array.from(
        new Map(productNameAndPrice.map((p) => [p.pName, p])).values()
      )

      colProductName = productNameAndPrice.map((p) => p.pName)
      colProductPrice = productNameAndPrice.map((p) => `$${p.pPrice}`)

      if (Array.isArray(listOfBuyerName)) {
        for (let i = 0; i < listOfBuyerName.length; i++) {
          const buyerName = listOfBuyerName[i]
          const { uPhone: buyerPhone } = groupByOrderWithBuyerName[buyerName][0]

          const buyerFirstName = buyerName ? buyerName.split(' ').slice(0, 1) : ''
          const buyerLastName = buyerName ? buyerName.split(' ').slice(1).join(' ') : ''

          const comments = groupByOrderWithBuyerName[buyerName].map((order) => order.comment)
          const commentCombined = comments.filter((comment) => comment !== null).join(', ').replace(/\r?\n/g, ' ')

          let totalAmount = 0
          let isPaid = false

          groupByOrderWithBuyerName[buyerName].forEach(order => {
            totalAmount += order.pPrice * order.pQuantity
            if (order.buyerStatus === BUYER_PAID) isPaid = true
          })

          const colOrderQuantity = new Array(colProductName.length).fill('')

          const _sum = sumUpdate(groupByOrderWithBuyerName[buyerName], 'pNameAndPid')
          const qtyLookup = {};
          for (const item of _sum) {
            const key = item.pName;
            const qty = Number(item.pQuantity) || 0;
            qtyLookup[key] = (qtyLookup[key] || 0) + qty;
          }
          for (let j = 0; j < colProductName.length; j++) {
            const productName = colProductName[j]
            if (qtyLookup[productName]) {
              colOrderQuantity[j] = qtyLookup[productName]
            }
          }

          const eventParticipation = new Array(eventHeaders.length).fill('No')
          const currentEventIndex = arrayEvent.findIndex(e => e.title === title)
          if (currentEventIndex >= 0) {
            eventParticipation[currentEventIndex] = 'Yes'
          }

          rowsOfContact.push([
            buyerFirstName,
            buyerLastName,
            buyerPhone,
            commentCombined,
            ...colOrderQuantity,
          ])

          paidAmounts.push(isPaid ? `$${totalAmount}` : '')
          unpaidAmounts.push(!isPaid ? `$${totalAmount}` : '')
          eventParticipations.push(eventParticipation)
        }
      }

      for (let index = 0; index < _totalOrderArr.length; index++) {
        const totalOrder = _totalOrderArr[index]

        const { pName, count } = totalOrder

        rowsOfTotalOrder[index] = [pName, count]
      }
      productNameAndPrice = Array.from(
        new Map(productNameAndPrice.map((p) => [p.pName, p])).values()
      )

      colProductName = productNameAndPrice.map((p) => p.pName)
      colProductPrice = productNameAndPrice.map((p) => `$${p.pPrice}`)

      const rows = [
        ['First Name', 'Last Name', 'Contact', 'Comment', ...colProductName, '', 'PAID', 'UNPAID', '', ...eventHeaders],
        ['', '', '', '', ...colProductPrice, '', '', '', '', ...eventHeaders.map(() => '')],
        ['-------------', '--------------', '------------', '------------', ...colProductName.map(() => '-----------------'), '', '---------------', '---------------', '', ...eventHeaders.map(() => '---------------')],
        ...rowsOfContact.map((row, index) => [
          ...row,
          '',
          paidAmounts[index],
          unpaidAmounts[index],
          '',
          ...eventParticipations[index]
        ]),
        [''],
        ['---------------------'],
        ['Payment Summary'],
        ['---------------------'],
        ...total,
        ['Total orders'],
        ['---------------------'],
        ...rowsOfTotalOrder,
      ]
      const formatSheetName = title.slice(0, 28)
      const CheckSheetNameIsExit = listTitle.includes(formatSheetName)
      let sheetAfterFormat
      if (CheckSheetNameIsExit) {
        sheetAfterFormat = `(1)${formatSheetName}`
        const checkSheetAfterFormatIsExit = listTitle.includes(sheetAfterFormat)
        if (checkSheetAfterFormatIsExit) {
          const countItemIsDuplicate = listTitle.filter((item) => item === sheetAfterFormat).length
          sheetAfterFormat = `$ ${countItemIsDuplicate + 1}{formatSheetName}`
        }
      } else {
        sheetAfterFormat = formatSheetName
      }
      const data = rows
      const ws = XLSX.utils.aoa_to_sheet(data)
      const safeName = safeSheetName(sheetAfterFormat)
      XLSX.utils.book_append_sheet(wb, ws, safeName)
      listTitle.push(sheetAfterFormat)
    }
    XLSX.writeFile(wb, 'Total order.xlsx')
  }

  if (fmt === format1) {
    const orderOfMultipleEvent = []
    listTotalOrderAfterFilter?.forEach((item) => {
      const updatedOrders = item.orders.map((order) => ({
        ...order,
        adminCost: item.adminCost ?? 0,
        discount: item.discount ?? 0,
        deliveryCost: item.deliveryCost ?? 0,
        payTogether: item.payTogether
      }))
      orderOfMultipleEvent.push(updatedOrders)
    })
    export1(orderOfMultipleEvent.flat())
  } else {
    export2(listTotalOrderAfterFilter)
  }
}
